import { DocumentCheckIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router';
import { buildContractsTabUrl } from '~/routing/urls';

/**
 * [MCV-1954] Shown wherever a response is viewed once both parties have accepted: the contract
 * now exists and waits for signatures on the Contracts page, which neither party is otherwise
 * told about. The new contract is PENDING, which only the Upcoming tab lists (the page otherwise
 * opens on Active), so the link opens Upcoming; these surfaces don't have the contract's id.
 */
export const ContractReadyNotice = () => (
  <div
    className="flex w-full flex-col gap-3 rounded-lg border border-primary-t-100 bg-primary-t-900/40 p-4 text-left sm:flex-row sm:items-center sm:justify-between"
    data-cy="contract-ready-notice"
    role="status"
  >
    <div className="flex items-center gap-3">
      <DocumentCheckIcon className="h-5 w-5 shrink-0 stroke-2 text-primary-t-50" />
      <p className="body-text-sb">
        Both parties have accepted. Your contract is ready to review and sign.
      </p>
    </div>
    {/* A link styled like the primary Button: Button only renders a <button>. */}
    <Link
      to={buildContractsTabUrl('upcoming')}
      data-cy="contract-ready-notice-link"
      className="body-text-sb inline-flex h-9 min-w-[88px] shrink-0 items-center justify-center rounded-control bg-primary-50 px-3 text-white hover:bg-primary-100 active:bg-primary-200 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-50"
    >
      Go to Contracts
    </Link>
  </div>
);
